import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams } from '../types';
import META from './useTrackPlansPageUpsellClicked.meta';

export type UseTrackPlansPageUpsellClickedParams = CreditAnalyticsParams;

export const useTrackPlansPageUpsellClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackPlansPageUpsellClicked = useCallback(
    (params: UseTrackPlansPageUpsellClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackPlansPageUpsellClicked };
};
